import { canUseDOM } from './can-use-dom';

/**
 * A basic utility for determining if scrollbars have a width,
 * and if they should be styled as a result. Typically we want to
 * leverage the "floating" mac os style scrollbars when possible, but
 * we want to avoid the ugly white scrollbars.
 */
export function getScrollBarWidth() {
  if (!canUseDOM()) return 0;

  const scrollBarEl = document.createElement('div');

  // set with an absolute and append off screen
  scrollBarEl.style.cssText =
    'width: 100px; height: 100px; overflow: scroll; position: absolute; top: -100px; left: -100px;';

  document.body.appendChild(scrollBarEl);

  // regular width
  const scrollBarWidth = scrollBarEl.offsetHeight - scrollBarEl.clientHeight;

  document.body.removeChild(scrollBarEl);

  return scrollBarWidth;
}
